const passwordParent = document.querySelector('.form-type-password-with-hints');
function checkStrength(pass) {
    const lowCase = passwordParent.querySelector('.low-case');
    const upperCase = passwordParent.querySelector('.upper-case');
    const number = passwordParent.querySelector('.one-number');
    const specialChar = passwordParent.querySelector('.one-special-char');
    const eightChar = passwordParent.querySelector('.eight-character');
    // If password contains a lowercase character
    if (pass.match(/([a-z])/)) {
        lowCase.classList.remove('error');
        lowCase.classList.add('ok');
    } else {
        lowCase.classList.add('error');
        lowCase.classList.remove('ok');
    }
    // If password contains a uppercase character
    if (pass.match(/([A-Z])/)) {
        upperCase.classList.remove('error');
        upperCase.classList.add('ok');
    } else {
        upperCase.classList.add('error');
        upperCase.classList.remove('ok');
    }
    // If it has numbers and characters
    if (pass.match(/([0-9])/)) {
        number.classList.remove('error');
        number.classList.add('ok');
    } else {
        number.classList.add('error');
        number.classList.remove('ok');
    }
    // If it has one special character
    if (pass.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) {
        specialChar.classList.remove('error');
        specialChar.classList.add('ok');
    } else {
        specialChar.classList.add('error');
        specialChar.classList.remove('ok');
    }
    // If password is greater than 7
    if (pass.length > 7) {
        eightChar.classList.remove('error');
        eightChar.classList.add('ok');
    } else {
        eightChar.classList.add('error');
        eightChar.classList.remove('ok');
    }
}
if (passwordParent) {
    const password = passwordParent.querySelector('.form-text');
    const passwordHints = passwordParent.querySelector('.password-hints');
    password.addEventListener('keyup', () => {
        const pass = password.value;
        if (pass !== '') {
            passwordHints.classList.remove('visually-hidden');
        } else {
            passwordHints.classList.add('visually-hidden');
        }
        checkStrength(pass);
        // Complete success
        if (passwordHints.querySelectorAll('.ok').length === 5) {
            passwordHints.classList.add('visually-hidden');
        } else {
            passwordHints.classList.remove('visually-hidden');
        }
    });
}
